export default "__VITE_ASSET__Ez734Z9Q__"